import React from "react"
import Link from "gatsby-link"
import { get } from "lodash"

import Bio from "../components/Bio"
import { rhythm } from "../utils/typography"

class BlogIndex extends React.Component {

  render() {
    const posts = get(this, "props.data.allMarkdownRemark.edges")

    return (
      <div>
        {posts.map(post => {
          if (post.node.path !== "/404/" && post.node.frontmatter.date) {
            const title = get(post, "node.frontmatter.title") || post.node.path
            return (
              <div>
                <h3 key={post.node.frontmatter.path}>
                  <Link
                    to={post.node.frontmatter.path}
                  >
                    {post.node.frontmatter.title}
                  </Link>
                </h3>
                <small>
                  {post.node.frontmatter.date}
                </small>
                <p dangerouslySetInnerHTML={{ __html: post.node.excerpt }} />
              </div>
            )
          }
        })}
        <hr />
      </div>
    )
  }
}

BlogIndex.propTypes = {
  route: React.PropTypes.object,
}

export default BlogIndex

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          frontmatter {
            path
            date(formatString: "MMMM YYYY")
            cover
          }
          frontmatter {
            title
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js